import { InformationButton } from "@components/buttons/information";
import { SHStack, SHTypography } from "@components/design-systems";
import { FieldTypeId } from "@models/configuration/feature";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { AnalysisDataValue } from "@models/platform-analysis/enums/dataValue";
import { memo } from "react";
import { RenderedProductCellByTypeComponentMap } from "../../../../configs";
import { BooleanCell } from "../../value-renders/boolean-cell";
import { MissingDataCell } from "../../value-renders/missing-data-cell";

type Props = {
  analysisData: AnalysisDataDTO;
};

export const FeatureProductCell = memo(({ analysisData }: Props) => {
  const renderValueByType = () => {
    const parsedTypeId = analysisData?.fieldTypeId as FieldTypeId;
    const RenderByTypeComponent =
      RenderedProductCellByTypeComponentMap[parsedTypeId];
    if (RenderByTypeComponent)
      return <RenderByTypeComponent analysisData={analysisData} />;
    return (
      <SHTypography
        variant="body3"
        zIndex="1"
        colorVariant="third"
        textAlign="justify"
      >
        {analysisData?.value}
      </SHTypography>
    );
  };

  const renderFeatureValue = () => {
    const dataValue = analysisData?.value as AnalysisDataValue;
    const dataType = analysisData?.fieldTypeId;

    if (dataValue === AnalysisDataValue.MissingData) return <MissingDataCell />;

    const isBooleanValue = [
      AnalysisDataValue.True,
      AnalysisDataValue.False,
    ].includes(dataValue);

    if (isBooleanValue || !dataType) return <BooleanCell value={dataValue} />;
    return renderValueByType();
  };

  const renderDescription = () => {
    if (!analysisData || !("description" in analysisData)) return null;
    if (!analysisData?.description) return null;
    return <InformationButton content={analysisData?.description} />;
  };

  return (
    <SHStack
      width={"100%"}
      alignItems={"center"}
      justifyItems={"center"}
      position={"relative"}
    >
      {renderFeatureValue()}
      <SHStack position={"absolute"} right={0}>
        {renderDescription()}
      </SHStack>
    </SHStack>
  );
});
